import React from 'react';
import { useTranslation } from 'react-i18next';
import { Placeholder } from '../Placeholder';
import { useFromToContext } from '../../../shared';
import { DateFromTo, UnpopularCategoriesComponent } from '../../../../generated/graphql';
import CategoriesView from './CategoriesView';

const UnpopularCategoriesList = () => {
    const { t } = useTranslation();
    const { dateFromTo } = useFromToContext();

    return (
        <UnpopularCategoriesComponent
            variables={{ dateFromTo: dateFromTo as DateFromTo }}
            fetchPolicy='network-only'
            Loader={() => <Placeholder minHeight={331} />}
        >
            {({ data: { unpopularCategories } }) => (
                <CategoriesView
                    title={t('Unpopular categories')}
                    categories={unpopularCategories}
                    itemsPerRow={3}
                />
            )}
        </UnpopularCategoriesComponent>
    );
};
export default UnpopularCategoriesList;